<script lang="ts">
  import { marked } from 'marked';

  let { content }: { content: string } = $props();

  const html = $derived(marked.parse(content, { breaks: true, gfm: true }) as string);
</script>

<div class="markdown-content">
  {@html html}
</div>

<style>
  .markdown-content :global(h1) { font-size: 1.5em; font-weight: 700; margin: 1em 0 0.5em; color: var(--theme-text-primary); }
  .markdown-content :global(h2) { font-size: 1.25em; font-weight: 600; margin: 0.8em 0 0.4em; color: var(--theme-text-primary); }
  .markdown-content :global(h3) { font-size: 1.1em; font-weight: 600; margin: 0.6em 0 0.3em; color: var(--theme-text-primary); }
  .markdown-content :global(p) { margin: 0.4em 0; line-height: 1.6; color: var(--theme-text-secondary); }
  .markdown-content :global(ul), .markdown-content :global(ol) { margin: 0.4em 0; padding-left: 1.5em; color: var(--theme-text-secondary); }
  .markdown-content :global(li) { margin: 0.2em 0; }
  .markdown-content :global(strong) { color: var(--theme-text-primary); font-weight: 600; }
  .markdown-content :global(em) { color: var(--theme-accent); }
  .markdown-content :global(code) { background: var(--theme-bg-card); padding: 0.15em 0.4em; border-radius: 4px; font-size: 0.85em; font-family: var(--font-mono); color: var(--theme-accent); }
  .markdown-content :global(pre) { background: var(--theme-bg-card); padding: 1em; border-radius: 8px; overflow-x: auto; margin: 0.5em 0; }
  .markdown-content :global(pre code) { background: none; padding: 0; }
  .markdown-content :global(table) { width: 100%; border-collapse: collapse; margin: 0.5em 0; font-size: 0.85em; }
  .markdown-content :global(th) { background: var(--theme-bg-card); padding: 0.4em 0.6em; text-align: left; border: 1px solid var(--theme-border); color: var(--theme-text-primary); font-weight: 600; }
  .markdown-content :global(td) { padding: 0.3em 0.6em; border: 1px solid var(--theme-border); color: var(--theme-text-secondary); }
  .markdown-content :global(tr:nth-child(even)) { background: rgba(255,255,255,0.02); }
  .markdown-content :global(blockquote) { border-left: 3px solid var(--theme-accent); padding-left: 1em; margin: 0.5em 0; color: var(--theme-text-muted); }
  .markdown-content :global(hr) { border: none; border-top: 1px solid var(--theme-border); margin: 1em 0; }
  .markdown-content :global(a) { color: var(--theme-accent); text-decoration: underline; }
</style>
